import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<path fill="url(#a)" d="M.5.0635h250v189.873H.5z" key="0" />,<defs key="1"><pattern id="a" width="1" height="1" patternContentUnits="objectBoundingBox"><use xlinkHref="#b" transform="matrix(.0005 0 0 .00066 0 -.127)" /></pattern></defs>,]
, 'GeneralSearchNeighbourhoodx');
